export const STORE_KEY = 'lessons';
